import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../../../../locale";

const TRANSFER_PATH = "/dashboard-financeiro/extracredit/transferir";

const TransferExtracreditCard = () => (
  <Link
    to={TRANSFER_PATH}
    className="card border-round-lg p-4 flex flex-column justify-content-center align-items-center gap-3 text-decoration-none cursor-pointer"
    style={{
      minWidth: "140px",
      border: "1px solid var(--theme-border, #EBEBEB)",
      color: "inherit",
    }}
  >
    <div
      className="flex align-items-center justify-content-center p-4"
      style={{
        width: "40px",
        height: "40px",
        border: "1px solid var(--theme-border, #EBEBEB)",
        borderRadius: "50%",
      }}
    >
      <i className="pi pi-sync text-md font-bold" style={{ color: "var(--theme-text, #171717)" }} />
    </div>
    <div>
      <span className="font-medium">{localeText("transferECR")}</span>
    </div>
  </Link>
);

export default TransferExtracreditCard;
